var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderWarehouse',{attrs:{"img_header":_vm.header_image,"header":"เพิ่มข้อมูลช่องทางติดต่อของแบรนด์ (Add brand contact)","link_back":"certificatesetting"}}),_c('Add_brand_contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }